<template>
  <Base :is-loading="dataIsLoad" :base-id="'lb-atm-info'" :base-class="'modal-sm'">
    <template #header>
      <h4 class="modal-title">ATM轉帳資訊</h4>
    </template>
    <template #body>
      <ul class="lh-15">
        <li>銀行代碼： {{ data.BankID }} {{ data.BankName }}</li>
        <li>轉帳帳號： {{ data.VirtualNumber }}</li>
        <li>轉帳金額： NT.{{ data.Price.toLocaleString() }}</li>
        <li>繳款期限： {{ data.Deadline }} 之前</li>
      </ul>
    </template>
    <template #footer>
      <div class="pb-2 w-50 mx-auto">
        <button type="button" class="btn w-100 btn-sm" @click.prevent="closeModal">確認</button>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import Base from '@global/components/common/modal/Base.vue';

import useAtmInfo from '@global/composable/order/useAtmInfo';
import useModalStore from '@global/stores/useModalStore';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);

const { data, dataIsLoad, fetchAPI } = useAtmInfo({
  transactionId: modalData.value,
});

onMounted(() => {
  fetchAPI();
});
</script>
